
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type MainContentRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function MainContentRT(): TemplateResult<MainContentRTRootProps> {
    return _createElement('div', {
        'id': 'itemsBlock',
        'className': 'cm_SearchPage'
    }, [this.CategoryPageCategoriesCarousel(function () {
            function repeatHierarchicalGroups1(hierarchicalGroups, hierarchicalGroupsIndex) {
                return [hierarchicalGroups(function () {
                        return _createElement('div', { 'className': 'cm_vehicle-categories_category-wrapper' + (this.isSelected ? ' selected' : '') }, _createElement('a', {
                            'className': 'cm_vehicle-categories_category-container cm_vehicle-categories_link',
                            'href': this.href
                        }, _createElement('div', { 'className': 'cm_vehicle-categories_category-image-container cm_vehicle-categories_link' }, _createElement('img', {
                            'className': 'cm_vehicle-categories_category-image',
                            'src': this.getImageOrDefault(this.imageUrl),
                            'alt': this.value
                        })), _createElement('div', { 'className': 'cm_vehicle-categories_category-title-container cm_vehicle-categories_link' }, _createElement('h2', { 'className': 'cm_vehicle-categories_category-title' }, this.value))));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_CategoryPageCategoriesCarousel' }, _createElement('div', { 'className': 'cm_vehicle-categories cm_vehicle-categories__subcategories cm_vehicle-categories__flat' }, _createElement.apply(this, [
                'div',
                {
                    'className': 'cm_vehicle-categories_category-wrapper-repeater  cmRepeater_hierarchicalGroups',
                    'data-cm-scroll-container': this.view === 'carousel'
                },
                _map(this.hierarchicalGroups, repeatHierarchicalGroups1.bind(this))
            ]), this.hierarchicalGroups?.length && this.view === 'carousel' ? [
                _createElement('button', {
                    'type': 'button',
                    'className': 'cm_vehicle-categories_category-scroll-button cm_vehicle-categories_category-scroll-button_left',
                    'onClick': this.scrollLeft,
                    'disabled': this.isLeftBorder,
                    'data-cm-scroll-left': true,
                    'key': '13971'
                }),
                _createElement('button', {
                    'type': 'button',
                    'className': 'cm_vehicle-categories_category-scroll-button cm_vehicle-categories_category-scroll-button_right',
                    'onClick': this.scrollRight,
                    'disabled': this.isRightBorder,
                    'data-cm-scroll-right': true,
                    'key': '13973'
                })
            ] : null));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], _createElement('div', { 'className': 'cm_SearchHeader__container' }, [this.SearchVehicleWidget_label(function () {
            return _createElement('div', { 'className': 'cm_vehicle-widget__label cm_mobile-hide cm_SearchVehicleWidget_label' }, _createElement('div', { 'className': 'cm_vehicle-widget__label-title' }, 'Your Vehicle:'), _createElement('div', { 'className': 'cm_vehicle-widget__label-button_container' }, _createElement('button', {
                'className': 'cm_vehicle-widget__label-button' + (this.isVehicleSelected ? ' selected' : ''),
                'onClick': this.openDialog
            }, [_createElement('svg', {
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'width': '15',
                    'height': '12',
                    'viewBox': '0 0 15 12',
                    'fill': 'none',
                    'key': '3480'
                }, _createElement('path', {
                    'fillRule': 'evenodd',
                    'clipRule': 'evenodd',
                    'd': 'M5 9.12566H3.919L3.577 10.1087L3.419 10.5628H1.5V7.70765C1.996 7.83124 2.713 7.92801 3.75 7.92801C3.94891 7.92801 4.13968 7.85231 4.28033 7.71754C4.42098 7.58278 4.5 7.40001 4.5 7.20943C4.5 7.01885 4.42098 6.83607 4.28033 6.70131C4.13968 6.56655 3.94891 6.49084 3.75 6.49084C2.677 6.49084 2.068 6.37587 1.752 6.28293C1.68269 6.26254 1.61459 6.23855 1.548 6.21107C1.62461 5.89504 1.79272 5.60612 2.033 5.37751C2.10633 5.30725 2.17767 5.23444 2.247 5.15906C3.772 5.57393 5.65 5.77226 7.5 5.77226C9.35 5.77226 11.228 5.57393 12.753 5.15906C12.8217 5.23507 12.893 5.30789 12.967 5.37751C13.208 5.60938 13.375 5.89873 13.452 6.21107C13.408 6.23151 13.34 6.25547 13.248 6.28293C12.932 6.37587 12.323 6.49084 11.25 6.49084C11.0511 6.49084 10.8603 6.56655 10.7197 6.70131C10.579 6.83607 10.5 7.01885 10.5 7.20943C10.5 7.40001 10.579 7.58278 10.7197 7.71754C10.8603 7.85231 11.0511 7.92801 11.25 7.92801C12.287 7.92801 13.004 7.83124 13.5 7.70765V10.5628H11.581L11.423 10.1087L11.081 9.12566H5ZM11.924 3.88285C10.644 4.17987 9.084 4.33508 7.5 4.33508C5.916 4.33508 4.356 4.17987 3.076 3.88285C3.10667 3.81132 3.136 3.73914 3.164 3.66632L3.612 2.46197C3.792 1.97812 4.182 1.68973 4.572 1.63512C6.5139 1.37062 8.4851 1.37062 10.427 1.63512C10.819 1.68973 11.207 1.97812 11.387 2.46197L11.837 3.66632C11.8637 3.73914 11.8927 3.81132 11.924 3.88285ZM10.272 11.3446L10 10.5628H5L4.728 11.3446C4.66165 11.5355 4.53428 11.7015 4.36395 11.8191C4.19362 11.9368 3.98896 12 3.779 12H1C0.734784 12 0.48043 11.8991 0.292893 11.7194C0.105357 11.5397 0 11.296 0 11.0419V6.61061C0 5.76747 0.35 4.95786 0.972 4.36191C1.13316 4.20794 1.27726 4.03841 1.402 3.85603H0.75C0.551088 3.85603 0.360322 3.78032 0.21967 3.64556C0.0790177 3.5108 0 3.32802 0 3.13744C0 2.94686 0.0790177 2.76409 0.21967 2.62933C0.360322 2.49456 0.551088 2.41886 0.75 2.41886H2.036L2.2 1.97812C2.543 1.05833 3.348 0.353162 4.357 0.213277C6.44182 -0.0710924 8.55818 -0.0710924 10.643 0.213277C11.652 0.353162 12.457 1.05833 12.8 1.97908L12.964 2.41886H14.25C14.4489 2.41886 14.6397 2.49456 14.7803 2.62933C14.921 2.76409 15 2.94686 15 3.13744C15 3.32802 14.921 3.5108 14.7803 3.64556C14.6397 3.78032 14.4489 3.85603 14.25 3.85603H13.599C13.7237 4.03871 13.8667 4.20734 14.028 4.36191C14.6503 4.95838 14.9999 5.76722 15 6.61061V11.0419C15 11.296 14.8946 11.5397 14.7071 11.7194C14.5196 11.8991 14.2652 12 14 12H11.22C11.0102 11.9998 10.8058 11.9365 10.6356 11.8189C10.4655 11.7013 10.3383 11.5354 10.272 11.3446Z',
                    'fill': 'white'
                }))], _createElement('span', { 'className': 'cm_vehicle-widget__label-button_text' }, this.isVehicleSelected ? `${ this.vehicleString }` : 'Add your vehicle'))));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.SearchHeader(function () {
            return _createElement('div', { 'className': 'cm_SearchHeader' }, _createElement('div', { 'className': 'cm_sort sort-by' }, _createElement('span', { 'className': 'sort-label' }, _translate(`sort_select_label`)), '\n  ', this.sortSelect, '\n'), [this.facetDialogButton(function () {
                    return _createElement('div', { 'className': 'cm_facetDialogButton' }, [this.dialogButton(function () {
                            return _createElement('div', { 'className': 'button--grey button--small button ' + (this.selectedFacetsCount ? 'cm_selected' : '') + ' cm_dialogButton' }, '\n  ', _translate(`facet_dialog_open_button`), '\n  ', this.selectedFacetsCount ? _createElement('span', {
                                'className': 'cm_count',
                                'key': '178'
                            }, ' ', this.selectedFacetsCount, ' ') : null, [_createElement('svg', {
                                    'className': 'cm_icon cm_filter-icon',
                                    'viewBox': '0 0 15 15',
                                    'key': '2720'
                                }, _createElement('path', {
                                    'd': 'M14 7.5H5.318m0 0c0 .427-.162.837-.45 1.14a1.494 1.494 0 0 1-1.082.472c-.407 0-.796-.17-1.084-.472a1.657 1.657 0 0 1-.448-1.14m3.064 0c0-.428-.162-.838-.45-1.14a1.494 1.494 0 0 0-1.082-.473c-.407 0-.796.17-1.084.472a1.657 1.657 0 0 0-.448 1.14m0 0H1m13 4.888H9.96m0 0c0 .428-.16.838-.448 1.14A1.494 1.494 0 0 1 8.428 14c-.406 0-.796-.17-1.083-.473a1.657 1.657 0 0 1-.449-1.14m3.065 0c0-.428-.162-.838-.45-1.14a1.495 1.495 0 0 0-1.083-.473c-.406 0-.796.17-1.083.473a1.657 1.657 0 0 0-.449 1.14m0 0H1m13-9.774h-2.182m0 0c0 .211-.04.421-.117.617a1.62 1.62 0 0 1-.332.523c-.143.15-.311.268-.497.35a1.465 1.465 0 0 1-.586.122c-.407 0-.796-.17-1.084-.472a1.657 1.657 0 0 1-.448-1.14m3.064 0c0-.212-.04-.422-.117-.618a1.62 1.62 0 0 0-.332-.523 1.528 1.528 0 0 0-.497-.35A1.465 1.465 0 0 0 10.286 1c-.407 0-.796.17-1.084.472a1.657 1.657 0 0 0-.448 1.14m0 0H1',
                                    'stroke': 'currentColor',
                                    'strokeMiterlimit': '10',
                                    'strokeLinecap': 'round'
                                }))]);
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'search-header',
            items: undefined
        })]), [this.FilterChips(function () {
            return _createElement('div', { 'className': 'cm_filterChips cm_filterChips__search-header cm_FilterChips' }, [this.filterChips(function () {
                    function repeatChips1(chips, chipsIndex) {
                        return [chips(function () {
                                function repeatI1_reviewChip(i, iIndex) {
                                    return _createElement('span', {
                                        'key': `${ this.field }|${ i }`,
                                        'className': 'cm_star cm_star__' + (!(this.value - i) || this.value - i < 0.25 ? 'empty' : this.value - i < 0.75 ? 'half' : 'full')
                                    });
                                }
                                return this.template === 'chip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_chip' }, _createElement('a', {
                                    'className': 'facetentrykey',
                                    'tabIndex': '0',
                                    'role': 'listitem'
                                }, this.name !== 'query' ? _createElement('span', {
                                    'className': 'cm_chip-name',
                                    'key': '95'
                                }, this.name === 'filterQuery' ? _translate(`filter_search_box_current_search`) : this.name, ':') : null, '\n  ', this.value, '\n'), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '3190'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'reviewChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_reviewChip' }, _createElement.apply(this, [
                                    'a',
                                    {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    },
                                    _createElement('span', { 'className': 'cm_chip-name' }, this.name, ': '),
                                    _map([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ], repeatI1_reviewChip.bind(this)),
                                    this.value !== '5' ? _createElement('span', { 'key': '391' }, ' and up') : null
                                ]), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '4900'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'rangeChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_rangeChip' }, _createElement('a', {
                                    'className': 'facetentrykey',
                                    'tabIndex': '0',
                                    'role': 'listitem'
                                }, _createElement('span', { 'className': 'cm_chip-name' }, this.name, ':'), this.finite ? [
                                    this.selectedRange[0],
                                    ' ',
                                    _translate(`ranged_facet_range_delimiter`),
                                    ' ',
                                    this.selectedRange[1]
                                ] : null, this.toPosInf ? [
                                    this.selectedRange[0],
                                    ' ',
                                    _translate(`ranged_facet_more`)
                                ] : null, this.toNegInf ? [
                                    this.selectedRange[1],
                                    ' ',
                                    _translate(`ranged_facet_less`)
                                ] : null), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '5360'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_filterChips' }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', {
                        'className': 'facettitle',
                        'tabIndex': '0'
                    }, _translate(`selected_facets_label`)), _createElement('div', { 'className': 'facetbody' }, _createElement.apply(this, [
                        'div',
                        {
                            'role': 'list',
                            'className': 'cmRepeater_chips'
                        },
                        _map(this.chips, repeatChips1.bind(this))
                    ]), _createElement('div', {
                        'className': 'button--clear button button--secondary cm_filter-chips_button',
                        'data-cm-role': 'start-over'
                    }, [_createElement('svg', {
                            'className': 'cm_icon cm_icon-times',
                            'height': '20px',
                            'role': 'img',
                            'viewBox': '0 0 22 22',
                            'key': '45110'
                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))], ' ', _translate(`selected_facets_clear`), '\n      '))));
                }, {
                    widgetName: 'filter-chips',
                    items: undefined
                })]);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.message(function () {
            return _createElement('div', { 'className': 'cm_message' }, this.demoPlanActive ? [_createElement('div', { 'key': '240' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.trialExpired ? [_createElement('div', { 'key': '3010' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                    'href': 'mailto:support@convermax.com',
                    'className': 'cm_message-link'
                }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.aggressiveWheels ? [_createElement('div', { 'key': '7510' }, _translate(`message_aggressive_wheels`, {  vehicleString : this. vehicleString  }))] : null, this.incompatibleParts ? [_createElement('div', {
                    'className': 'cm_message__incompatible',
                    'key': '8800'
                }, _createElement('div', {}, _translate(`message_incompatible_text_results`, {  vehicleString : this. vehicleString  })))] : null, this.nonVehicleSpecificResults ? [_createElement('div', {
                    'className': 'cm_message__nothing-for-vehicle',
                    'key': '10670'
                }, '\n  ', _translate(`message_non_vehicle_specific_results`, {  vehicleString : this. vehicleString  }), '\n  ', _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'href': this.searchByVehicleUrl
                }, _translate(`message_view_compatible_products`)))] : null, this.template === 'badRequest' ? _createElement('div', {
                'className': 'cmTemplate_badRequest',
                'key': '1390'
            }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.startOver
            }, _translate(`message_reset_search`)), _createElement('br', {}), this.error ? [
                '\n    (',
                this.error.status ? [
                    _createElement('b', { 'key': '16790' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '17660' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '18490' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '16424' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null)) : null, this.template === 'corrected' ? _createElement('div', {
                'className': 'cmTemplate_corrected',
                'key': '2012'
            }, _createElement('div', {}, _translate(`message_query_corrected`, { 
                originalQuery: this.
                originalQuery, 
                query
            : this.
                query
             }))) : null, this.template === 'networkError' ? _createElement('div', {
                'className': 'cmTemplate_networkError',
                'key': '2179'
            }, _createElement('div', {}, '\n  ', _translate(`message_network_error`), '\n  ', _createElement('br', {}), this.error ? [
                '\n    (',
                this.error.status ? [
                    _createElement('b', { 'key': '23610' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '24480' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '25310' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '23244' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null)) : null, this.template === 'nothing' ? _createElement('div', {
                'className': 'cmTemplate_nothing',
                'key': '2694'
            }, _createElement('div', { 'className': 'cmTemplate_nothing-container' }, this.isSearchedByVehicle ? [
                _createElement('div', {
                    'className': 'cmTemplate_nothing-header',
                    'key': '28171'
                }, 'Oof...nothing currently fits your vehicle'),
                _createElement('div', {
                    'className': 'cmTemplate_nothing-text',
                    'key': '28173'
                }, '\n      It looks like we don\'t have anything for that vehicle yet. If you\'d like to browse our product you can\n      remove your vehicle.\n    '),
                _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cmTemplate_nothing-button',
                    'onClick': this.startOver,
                    'key': '28175'
                }, 'Show Products That Do Fit My Vehicle')
            ] : null, !this.isSearchedByVehicle ? [
                _createElement('div', {
                    'className': 'cmTemplate_nothing-header',
                    'key': '32931'
                }, 'We can\'t find products matching the selection'),
                _createElement('div', {
                    'className': 'cmTemplate_nothing-text',
                    'key': '32933'
                }, 'Sorry, we couldn\'t find products matching your selection.'),
                this.query || this.isFacetsSelected ? _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cmTemplate_nothing-button',
                    'onClick': this.startOver,
                    'key': '32935'
                }, _translate(`message_reset_search`)) : null
            ] : null)) : null, this.template === 'partial' ? _createElement('div', {
                'className': 'cmTemplate_partial',
                'key': '3747'
            }, _createElement('div', {}, _translate(`message_query_partial`, {  originalQuery : this. originalQuery  }))) : null, this.template === 'timeout' ? _createElement('div', {
                'className': 'cmTemplate_timeout',
                'key': '3901'
            }, _createElement('div', {}, '\n  ', _translate(`message_timeout`), '\n  ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.retry
            }, _translate(`message_retry_search`)))) : null, this.template === 'unknown' ? _createElement('div', {
                'className': 'cmTemplate_unknown',
                'key': '4141'
            }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.retry
            }, _translate(`message_retry_search`)), _createElement('br', {}), this.error ? [
                '\n    (',
                this.error.status ? [
                    _createElement('b', { 'key': '44200' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '45070' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '45900' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '43834' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null)) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.customMessage(function () {
            return _createElement('div', { 'className': 'cm_message cm_customMessage' }, []);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.SearchResult(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('li', {}, _createElement('article', {
                            'className': 'card',
                            'data-event-type': 'list',
                            'data-name': this.removeHTML(this.name),
                            'data-product-brand': this.removeHTML(this.brand_name),
                            'data-product-price': this.price
                        }, _createElement('form', {
                            'className': 'card-inner',
                            'method': 'post',
                            'action': '/cart.php',
                            'encType': 'multipart/form-data'
                        }, _createElement('figure', { 'className': 'card-figure' }, !this.out_of_stock && this.on_sale ? _createElement('div', {
                            'className': 'product-badge product-badge--sale',
                            'key': '320'
                        }, _createElement('span', { 'className': 'product-badge__text body-xs' }, 'On Sale!')) : null, _createElement('a', {
                            'href': this.custom_url,
                            'className': 'card-figure__link',
                            'aria-label': this.removeHTML(this.name),
                            'data-event-type': 'product-click'
                        }, _createElement('div', { 'className': 'card-img-container' }, _createElement('img', {
                            'src': this.imageOrDefault(this.images_image_standard1),
                            'alt': this.removeHTML(this.name),
                            'title': this.removeHTML(this.name),
                            'data-sizes': 'auto',
                            'className': 'card-image lazyautosizes ls-is-cached lazyloaded',
                            'sizes': '424px',
                            'onError': this.onImageError
                        })))), _createElement('div', { 'className': 'card-body text-center text-common-white' }, _createElement('h3', { 'className': 'card-title' }, _createElement('a', Object.assign({}, {
                            'aria-label': this.removeHTML(this.name),
                            'href': this.custom_url,
                            'data-event-type': 'product-click'
                        }, { dangerouslySetInnerHTML: { __html: typeof this.name === 'undefined' ? '' : this.name } }))), _createElement('div', {
                            'className': 'card-text card-price-wrapper',
                            'data-test-info-type': 'price'
                        }, this.retail_price > this.price ? _createElement('div', {
                            'className': 'price-section price-section--withoutTax rrp-price--withoutTax',
                            'key': '1427'
                        }, _createElement('span', { 'className': 'price price--rrp' }, this.formatPrice(this.retail_price))) : null, this.on_sale ? _createElement('div', {
                            'className': 'price-section price-section--withoutTax non-sale-price--withoutTax',
                            'key': '1660'
                        }, _createElement('span', { 'className': 'price price--non-sale' }, this.formatPrice(this.regular_price))) : null, _createElement('div', { 'className': 'price-section price-section--withoutTax price--withoutTax' }, this.has_options && !this.on_sale ? _createElement('span', {
                            'className': 'price-label',
                            'key': '1967'
                        }, 'Starting at ') : null, _createElement('span', { 'className': 'price' }, this.formatPrice(this.price)))), _createElement('a', {
                            'className': 'card-add-to-cart-button cm_desktop-hide',
                            'href': this.custom_url
                        }, 'Shop Now')), _createElement('div', {
                            'onClick': () => window.Convermax.openProductInformationDialog(this),
                            'className': 'card-product-information'
                        }, _createElement('span', { 'className': 'card-product-information-title' }, 'Product Information'), _createElement('svg', {
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'width': '40',
                            'height': '40',
                            'viewBox': '0 0 40 40',
                            'fill': 'none'
                        }, _createElement('circle', {
                            'cx': '20',
                            'cy': '20',
                            'r': '20',
                            'fill': 'black'
                        }), _createElement('line', {
                            'x1': '14',
                            'y1': '19.5',
                            'x2': '26',
                            'y2': '19.5',
                            'stroke': 'white'
                        }), _createElement('line', {
                            'x1': '20.5',
                            'y1': '14',
                            'x2': '20.5',
                            'y2': '26',
                            'stroke': 'white'
                        }))))));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_SearchResult' }, _createElement('div', { 'className': 'hero-title heading-h2' }, window.Convermax.categoryTitle), _createElement.apply(this, [
                'ul',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.message(function () {
                    return _createElement('div', { 'className': 'cm_message' }, this.demoPlanActive ? [_createElement('div', { 'key': '240' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.trialExpired ? [_createElement('div', { 'key': '3010' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                            'href': 'mailto:support@convermax.com',
                            'className': 'cm_message-link'
                        }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.aggressiveWheels ? [_createElement('div', { 'key': '7510' }, _translate(`message_aggressive_wheels`, {  vehicleString : this. vehicleString  }))] : null, this.incompatibleParts ? [_createElement('div', {
                            'className': 'cm_message__incompatible',
                            'key': '8800'
                        }, _createElement('div', {}, _translate(`message_incompatible_text_results`, {  vehicleString : this. vehicleString  })))] : null, this.nonVehicleSpecificResults ? [_createElement('div', {
                            'className': 'cm_message__nothing-for-vehicle',
                            'key': '10670'
                        }, '\n  ', _translate(`message_non_vehicle_specific_results`, {  vehicleString : this. vehicleString  }), '\n  ', _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'href': this.searchByVehicleUrl
                        }, _translate(`message_view_compatible_products`)))] : null, this.template === 'badRequest' ? _createElement('div', {
                        'className': 'cmTemplate_badRequest',
                        'key': '1390'
                    }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.startOver
                    }, _translate(`message_reset_search`)), _createElement('br', {}), this.error ? [
                        '\n    (',
                        this.error.status ? [
                            _createElement('b', { 'key': '16790' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '17660' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '18490' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '16424' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null)) : null, this.template === 'corrected' ? _createElement('div', {
                        'className': 'cmTemplate_corrected',
                        'key': '2012'
                    }, _createElement('div', {}, _translate(`message_query_corrected`, { 
                        originalQuery: this.
                        originalQuery, 
                        query
                    : this.
                        query
                     }))) : null, this.template === 'networkError' ? _createElement('div', {
                        'className': 'cmTemplate_networkError',
                        'key': '2179'
                    }, _createElement('div', {}, '\n  ', _translate(`message_network_error`), '\n  ', _createElement('br', {}), this.error ? [
                        '\n    (',
                        this.error.status ? [
                            _createElement('b', { 'key': '23610' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '24480' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '25310' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '23244' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null)) : null, this.template === 'nothing' ? _createElement('div', {
                        'className': 'cmTemplate_nothing',
                        'key': '2694'
                    }, _createElement('div', { 'className': 'cmTemplate_nothing-container' }, this.isSearchedByVehicle ? [
                        _createElement('div', {
                            'className': 'cmTemplate_nothing-header',
                            'key': '28171'
                        }, 'Oof...nothing currently fits your vehicle'),
                        _createElement('div', {
                            'className': 'cmTemplate_nothing-text',
                            'key': '28173'
                        }, '\n      It looks like we don\'t have anything for that vehicle yet. If you\'d like to browse our product you can\n      remove your vehicle.\n    '),
                        _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cmTemplate_nothing-button',
                            'onClick': this.startOver,
                            'key': '28175'
                        }, 'Show Products That Do Fit My Vehicle')
                    ] : null, !this.isSearchedByVehicle ? [
                        _createElement('div', {
                            'className': 'cmTemplate_nothing-header',
                            'key': '32931'
                        }, 'We can\'t find products matching the selection'),
                        _createElement('div', {
                            'className': 'cmTemplate_nothing-text',
                            'key': '32933'
                        }, 'Sorry, we couldn\'t find products matching your selection.'),
                        this.query || this.isFacetsSelected ? _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cmTemplate_nothing-button',
                            'onClick': this.startOver,
                            'key': '32935'
                        }, _translate(`message_reset_search`)) : null
                    ] : null)) : null, this.template === 'partial' ? _createElement('div', {
                        'className': 'cmTemplate_partial',
                        'key': '3747'
                    }, _createElement('div', {}, _translate(`message_query_partial`, {  originalQuery : this. originalQuery  }))) : null, this.template === 'timeout' ? _createElement('div', {
                        'className': 'cmTemplate_timeout',
                        'key': '3901'
                    }, _createElement('div', {}, '\n  ', _translate(`message_timeout`), '\n  ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.retry
                    }, _translate(`message_retry_search`)))) : null, this.template === 'unknown' ? _createElement('div', {
                        'className': 'cmTemplate_unknown',
                        'key': '4141'
                    }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.retry
                    }, _translate(`message_retry_search`)), _createElement('br', {}), this.error ? [
                        '\n    (',
                        this.error.status ? [
                            _createElement('b', { 'key': '44200' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '45070' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '45900' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '43834' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null)) : null);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'results',
            items: undefined
        })], [this.pagination(function () {
            function repeatButtons1(buttons, buttonsIndex) {
                return [buttons(function () {
                        return this.template === 'prev' ? _createElement('li', {
                            'className': 'pagination-item pagination-item--previous cmTemplate_prev',
                            'href': this.pageLink
                        }, _createElement('a', {
                            'className': 'pagination-link',
                            'href': this.pageLink,
                            'data-faceted-search-facet': true,
                            'aria-label': 'Previous'
                        }, _createElement('button', {
                            'type': true,
                            'className': 'button button--grey button--icon'
                        }, _createElement('span', { 'className': 'button__wrapper' }, _createElement('span', { 'className': 'icon icon--arrow-left button__leading-icon' }, _createElement('span', { 'className': 'visually-hidden' }, 'arrow-left'), _createElement('svg', { 'viewBox': '0 0 17 15' }, _createElement('path', {
                            'd': 'M7 1 1 7.5 7 14M1 7.5h16',
                            'stroke': 'currentColor',
                            'fill': 'transparent'
                        }))))))) : this.template === 'next' ? _createElement('li', {
                            'className': 'pagination-item pagination-item--next cmTemplate_next',
                            'href': this.pageLink
                        }, _createElement('a', {
                            'className': 'pagination-link',
                            'href': this.pageLink,
                            'data-faceted-search-facet': true,
                            'aria-label': 'Next'
                        }, _createElement('button', {
                            'type': true,
                            'className': 'button button--grey button--icon'
                        }, _createElement('span', { 'className': 'button__wrapper' }, _createElement('span', { 'className': 'icon icon--arrow button__leading-icon' }, _createElement('span', { 'className': 'visually-hidden' }, 'arrow'), _createElement('svg', { 'viewBox': '0 0 17 15' }, _createElement('path', {
                            'd': 'm10 1 6 6.5-6 6.5M16 7.5H0',
                            'stroke': 'currentColor',
                            'fill': 'transparent'
                        }))))))) : this.template === 'delimiter' ? _createElement('li', { 'className': 'pagination-item pagination-item--delimiter no-js cmTemplate_delimiter' }, '...') : this.template === 'page' ? _createElement('li', {
                            'className': 'pagination-item' + (this.isActive ? ' pagination-item--current' : '') + ' cmTemplate_page',
                            'href': this.pageLink
                        }, _createElement('a', {
                            'href': this.pageLink,
                            'className': 'pagination-link'
                        }, this.page)) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                    }, { count: undefined })];
            }
            return _createElement('nav', { 'className': 'pagination cm_pagination' }, _createElement.apply(this, [
                'ul',
                { 'className': 'pagination-list cmRepeater_buttons' },
                _map(this.buttons, repeatButtons1.bind(this))
            ]));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:CategoryPageCategoriesCarousel","cm:SearchVehicleWidget_label","cm:dialogButton","cm:facetDialogButton","cm:SearchHeader","cm:filterChips","cm:FilterChips","cm:message","cm:customMessage","cm:message","cm:SearchResult","cm:pagination"]